import {
  BooleanInput,
  CheckboxGroupInput,
  Create,
  CreateContextProvider,
  DateTimeInput,
  Form,
  required,
  SaveButton,
  SelectInput,
  TextInput,
  NumberInput,
  Toolbar,
  TopToolbar,
  useCreateController,
  useNotify,
  useRecordContext,
  useRedirect,
  useTranslate,
} from 'react-admin';
import {
  Box,
  Card,
  Divider,
  Stack,
  Typography,
  Button as MUIButton,
  Tooltip,
  IconButton,
} from '@mui/material';
import { Resources } from '../resource';

import CustomTagInput from 'src/pages/admin/components/CustomTagInput';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useEffect, useRef, useState, useCallback } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import useAgentInfo from './useAgentInfo';
import { chains } from 'src/assets/data';

interface FormProps {
  isCreate: boolean;
}
const SetUnlimitedForm = (props: FormProps) => {
  const { isCreate } = props;
  const t = useTranslate();
  const redirect = useRedirect();
  const { watch, setValue, trigger } = useFormContext();
  const record = useRecordContext();
  const { findAgentInfo } = useAgentInfo();
  const [addressMessage, setAddressMessage] = useState('');
  const id = useWatch({ name: 'id' });
  const [noCreate, setNoCreate] = useState<boolean>(true);

  const loadForEdit = useCallback(async () => {
    setAddressMessage('');
    const curId = (id ?? '').trim();
    if (!curId) return;

    try {
      const agent = await findAgentInfo(curId);
      if (!agent) return;
      setNoCreate(true);
      setValue('userId', agent.userId);
      setValue('commissionRateN', agent.commissionRateN);
      setValue('status', agent.status);
    } catch {
      setAddressMessage('module.agentInfo.validate.required');
    }
  }, [id, setValue, findAgentInfo]);

  const hasTypedRef = useRef(false);

  useEffect(() => {
    if (isCreate) return;
    loadForEdit().catch(() => {});
  }, [isCreate, loadForEdit]);

  return (
    <>
      <Stack spacing={3} gap={2}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={2}
          mb={1}
        >
          <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
            {t('module.agentInfo.userId')}
          </Typography>
          <Box sx={{ flexGrow: 1 }}>
            <TextInput
              label={false}
              source="userId"
              validate={[required()]}
              placeholder={t('module.agentInfo.userId')}
              InputProps={{ readOnly: !isCreate }}
              fullWidth
              helperText={<span style={{ color: 'red' }}></span>}
              type="string"
            />
          </Box>
        </Stack>

        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={2}
          mb={1}
        >
          <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
            {t('module.agentInfo.commissionRateN')}
          </Typography>
          <Box sx={{ flexGrow: 1 }}>
            <NumberInput
              label={false}
              source="commissionRateN"
              validate={[required()]}
              placeholder={t('module.agentInfo.commissionRateN')}
              fullWidth
              helperText={<span style={{ color: 'red' }}></span>}
              type="number"
            />
          </Box>
        </Stack>

        <Stack direction={'row'} alignItems={'center'} spacing={2} mb={1}>
          <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
            {t('module.agentInfo.status')}
          </Typography>
          <Box sx={{ flexGrow: 1 }}>
            <BooleanInput
              label=""
              source="status"
              helperText={<span style={{ color: 'red' }}>{''}</span>}
              format={(v) => v === 'ACTIVE' || v === true}
              parse={(v) => (v ? 'ACTIVE' : 'INACTIVE')}
            />
          </Box>
        </Stack>
      </Stack>
    </>
  );
};

export default SetUnlimitedForm;
